import { MEDICAL_EXAMINATION_TRANSLATION_MAP } from './medicalExaminationTranslationMap';
import { MedicalExaminationType } from '../../../../graphql/graphql';

export const DENTITION_VISIT_TYPE_OPTIONS = [
	{
		label: MedicalExaminationType.Initial,
		value: MedicalExaminationType.Initial,
		title: MEDICAL_EXAMINATION_TRANSLATION_MAP[MedicalExaminationType.Initial],
	},
	{
		label: MedicalExaminationType.DentalTreatmentRestoration,
		value: MedicalExaminationType.DentalTreatmentRestoration,
		title:
			MEDICAL_EXAMINATION_TRANSLATION_MAP[
				MedicalExaminationType.DentalTreatmentRestoration
			],
	},
	{
		label: MedicalExaminationType.Emergency,
		value: MedicalExaminationType.Emergency,
		title:
			MEDICAL_EXAMINATION_TRANSLATION_MAP[MedicalExaminationType.Emergency],
	},
	{
		label: MedicalExaminationType.Preventive,
		value: MedicalExaminationType.Preventive,
		title:
			MEDICAL_EXAMINATION_TRANSLATION_MAP[MedicalExaminationType.Preventive],
	},
];
